var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VideosFilterBase',{attrs:{"list":_vm.tagsFilters,"selected":_vm.selectedTags,"mutation":"Tag","field":"tag"}},[_vm._v(" Sesiones Temáticas ")])}
var staticRenderFns = []

export { render, staticRenderFns }